<script>
    import { state, ui, prefs, res  } from './stores.js';
    import Card from './Card.svelte';
    import Dashboard from './Dashboard.svelte';
    import Breakdown from './Breakdown.svelte';
    import { getPlayerIndex, updateState } from './game.js';

    // Key each player's view by captain so the Borg Queen's 'You are the second player' swap
    // moves the two views rather than handing each one the other player. Reused, the view's
    // Assimilated/Log branch flipped and the old branch's crossfade outros never finished,
    // leaving the opponent's captain cards stuck in the row. Repeated captains fall back to seat.
    function playerKey(players, p, i){
        return players.filter(o => o.captain == p.captain).length > 1 ? `seat ${i}` : p.captain;
    }
    import { allScoreableCards, scorePlayer } from './scores.js'
    import TokenEdit from './TokenEdit.svelte';
    import { get } from 'svelte/store';
    import { cardsInPlay, faceupDraw, howManyOnDuty, lookAtCards, possArray } from './card_actions.js';
    import { getDashboard } from './card_images.js';
    import { blur } from 'svelte/transition';
    import { afterUpdate } from 'svelte';
    import tippy from 'tippy.js';
    import 'tippy.js/dist/tippy.css'; // optional for styling
    import { tick } from 'svelte/internal';
    import { ongoingPlayer, upperInitial } from './parse.js';
    import { displayMemo } from './displaymemo.js';
    import { convert } from './ui.js';
    import { humanReadableRewards, eligibleRewards, campaignRewards } from './campaign.js';
    import LogCard from './LogCard.svelte';
    import ActionBit from './ActionBit.svelte';
    import { collectableTraits, desiredTraits, getTraitTicks } from './khan.js';
    import StandardBoard from './newcards/board/StandardBoard.svelte';
    import KhanBoard from './newcards/board/unique/KhanBoard.svelte';
    import JanewayBoard from './newcards/board/unique/JanewayBoard.svelte';
    import { isMe } from './net.js';
    import { botLevels, fakeBotAction } from './bot.js';
    import TreacheryBoard from './newcards/board/unique/TreacheryBoard.svelte';
    import BorgQueenBoard from './newcards/board/unique/BorgQueenBoard.svelte';
    import QBoard from './newcards/board/unique/QBoard.svelte';
    import BotChart from './newcards/bot/BotChart.svelte';
    import { perfCount } from './perf.js';

    let tip;
    let tipElement = [];
    let breakdownElement;
    afterUpdate(() => perfCount('render.PlayerView.afterUpdate'));

    function toggleChart(p, place){
        if($ui.chart != false){
            $ui.chart = false;
        }else{
            $ui.chart = {p, place};
        }
        console.log($ui.chart)
    }

    function trackTypesToShow(p){
        let tracks = $res.trackTypes;
        if(p.captain == 'Borg Queen'){
            tracks = ['collective'];
        }else if(p.captain == 'Q'){
            return [];
        }else{
            tracks = ['research', 'influence', 'military'];
        }
        if($res.modules.includes('Treachery')) tracks = [...tracks, 'treachery'];
        return tracks;
    }

    function trackMax(t){
        if(t == 'collective') return $res.collectiveMax;
        return $res.trackMax;
    }

    function reserveName(p){
        let elements = [];
        if(p.decks.reserve.length > 0) elements.push('reserve');
        //if(p.decks.missions.filter(c => c.deck == 'Missions').length > 0) elements.push('dev');
        return (elements.join(' & '));
    }
    function playAreaHeight(scale){
        //return $res.cardHeight * scale; // Not sure about this
        let marketHeight = $res.cardHeight * scale * 1.2;
        let topHeight = 8;
        let bottomHeight = 8;
        let hand = $res.cardHeight * scale * 1.1

        let height = 100 - hand - topHeight - marketHeight - bottomHeight - 10;
        if(height > $res.cardHeight * scale * 1.1) return height;
        return $res.cardHeight * scale * 1.1; // hopefully not needed
    }


    function shouldWrap(height){
        if(height >= 2 * $prefs.cardScale * h) return 'wrap';
        return 'nowrap';
    }

    function setActivePlayer(i){
        console.log($state.players[i].scoreBreakdown);
        if($state.activePlayer == i) return;
        if(!confirm(`Really set the active player to ${$state.players[i].captain}? Don't mess with this unless something has gone wrong!`)) return;
        $state.activePlayer = i;
        updateState();
    }

    function showHide(p, ui, prefs){
        if(p == ui.viewing || prefs.showBoth){
            if(ui.animate) return 'shown';
            return '';
        }else{
            return 'hidden';
        }
    }

    function divideWidth(p, ui, prefs){
        if(prefs.showBoth) return 'min-width: 50vw;';
        if(p == ui.viewing) return 'min-width: 80vw;';
        return '';
    }

    let tempUI;
    let playerColours = ['midnightblue', 'darkred']
    let tipShowing = -1;

    $: tempUI = $ui;

    function showBreakdown(i){
        console.log('click')
        if(tip && tipShowing == i){
            tip.hide();
            tip.destroy();
            tip = false;
            tipShowing = -1;
            console.log('hidden')
        }else if(tipElement[i]){
            tip = tippy(tipElement[i], {
                content: breakdownElement,
                trigger: 'manual',
                interactive: true,
                appendTo: document.body,
                onHidden(instance) {
                    tipShowing = -1;
                },
                maxWidth: 'none'
            });
            if(tip) tip.show();
            tipShowing = i;
        }
    }

    function maybeFakeBotAction(e, p, row, type){
        if(!e.altKey || !e.shiftKey) return;
        fakeBotAction(p, row, type);
    }

</script>
<div style="display: flex; width: 100%; align-items: flex-end; background-color:{playerColours[$ui.viewing]}">
{#each $state.players as p, i (playerKey($state.players, p, i))} <!---->
<!--style={p == $ui.viewing ? '' : 'display:none;'} -->
    
    <div style="order: 0; {$prefs.animatePlayerView ? `--translate: ${-100 + getPlayerIndex(p) * 2 * 100}vw` : ''} {$ui.viewing == getPlayerIndex(p)  && !$prefs.showBoth ? '' : 'display: none;'}" class="area">
        {#if p.bot}
            <div class="row">
                {p.botLevel}
            </div>
        {/if}
        <div class="row" style="align-items: center;">
            <span on:click={e => {setActivePlayer(i)}} style="cursor: pointer; {$state.activePlayer == i ? 'font-weight: bold;' : ''}">{#if $state.activePlayer == i}👉{/if}{p.captain}</span>
            {#each Array(p.stardateCards.length) as a}
                <div style="font-weight: bold; color: yellow; font-size: 1.5em;">!</div>
            {/each}
            
            {#each trackTypesToShow(p) as r}
                <TokenEdit inc={1} max={trackMax(r)} {p} {r} size={4} />
            {/each} 
            <!--<button class="toolbutton" style="font-size: 2vmin;" on:click={e => { $ui.showingTrack = !$ui.showingTrack; }}>Track</button>-->
            {#if $prefs.showScores}<div style="cursor: pointer;" on:click={e => {$ui.showingScore = !$ui.showingScore}}>({p.score || 0} VP)</div>{/if}<!---->
            <button bind:this={tipElement[i]} class="toolbutton" style="font-size: 2vmin;" on:click={e => {showBreakdown(i)}}>Info</button>
            {#if p.bot}
                <button class="toolbutton" style="font-size: 2vmin;" on:click={e => {toggleChart(p, 1)}}>Chart</button>
            {/if}
        </div>
        
        <div class="row"> 
            
            <div class="scroll zone" style="flex-wrap: nowrap; height: {$res.cardHeight * $prefs.cardScale * 2}vmin;">

                <div style="display: flex; justify-content: center; flex-direction: column; height: {$res.cardHeight * $prefs.cardScale * 2}vmin; {$res.modules.includes('Treachery') && !p.bot ? 'overflow-y: auto;' : ''} flex-wrap: nowrap; --width: {$res.cardWidth * $prefs.cardScale}vmin; --height: {$res.cardHeight * $prefs.cardScale}vmin;">
                
                        {#if $prefs.oldCards}
                            <Dashboard {p} hide={$ui.viewing != getPlayerIndex(p) && !$prefs.showBoth} />
                        {:else}
                            {#if p.captain == 'Khan'}
                                <KhanBoard {p} board={p.dashboard} />
                            <!--{:else if p.captain == 'Janeway' && p.dashSide == 'advanced' }
                                <JanewayBoard {p} board={p.dashboard} />-->
                            {:else if p.captain == 'Borg Queen'}
                                <BorgQueenBoard {p} board={p.dashboard} />
                            {:else if p.captain == 'Q'}
                                {#if !p.bot}
                                    <div style="display: flex; width: min-content;">
                                        <Card c={p.decks.continuum[0]} bind:deck={p.decks.continuum} facedown name="continuum" />
                                        {#each p.decks.missions as c, index}
                                            <Card single bind:deck={p.decks.missions} {c} {index}/>
                                        {/each}
                                    </div>
                                {/if}
                                <QBoard {p} board={p.dashboard} />
                            {:else if p.dashboard}
                                <StandardBoard {p} board={p.dashboard} side={p.dashSide} />
                            {/if}
                        {/if}

                        <!-- Don't think this works like this anymore {#if $res.modules.includes('Treachery') && !p.bot}
                            <TreacheryBoard {p} />
                        {/if}-->
                    </div>
                </div>
            </div>
        <div class="row">
            {#if p.bot}
                <Card facedown c={p.decks.reserve[0]} bind:deck={p.decks.reserve} name="supplement"/>
            {:else}
                <Card c={p.decks.dev[0]} bind:deck={p.decks.dev} name="dev"/>
            {/if}
            {#if !p.bot}
                <div style={p.decks.reserve.length > 0 ? '' : 'display: none;'}>
                    <Card facedown c={p.decks.reserve[0]} bind:deck={p.decks.reserve} tuckDeck={p.decks.dev} tuckName="dev" name={reserveName(p)}/>
                </div>
                <div style={p.decks.reserve.length > 0 || p.decks.missions.filter(c => c.deck == 'Missions').length == 0 ? 'display: none;' : ''}>
                    <Card c={p.decks.dev[0]}  bind:deck={p.decks.dev} name="dev"/>
                </div>
            {/if}
            <Card c={p.decks.discard[0]} bind:deck={p.decks.discard} name="discard" />
        </div>
        </div>

    

    <div style="{$prefs.animatePlayerView ? `--translate: ${-100 + getPlayerIndex(p) * 2 * 100}vw` : ''} {$ui.viewing ==  getPlayerIndex(p) && !$prefs.showBoth? '' : 'display: none;'}" class="area growable">
    <div class="row">
            <Card hide={$ui.viewing != getPlayerIndex(p)} single name="duty" bind:deck={p.decks.duty} c={p.decks.duty[0]} index=0 />
            {#each p.decks.duty.slice(1) as c, index}
                <Card hide={$ui.viewing != getPlayerIndex(p)} single name="duty {index+2}" bind:deck={p.decks.duty} {c} {index}/>
            {/each}
            <div class="scroll zone" style="flex-wrap: nowrap; height: {$res.cardHeight * $prefs.cardScale * 1.1}vmin;">
                <div class="legend" style="pointer-events: auto; color: lightgrey; font-size: {$prefs.cardScale}em; left: 0;">{p.captain != 'Q' && p.decks.missions && p.decks.missions.length > 0 ? 'MISSIONS & ': ''}LOCATIONS</div>
                <div style="display: flex; flex-wrap: nowrap; ">
                    <!--{#if p.captain == 'Janeway' && p.dashSide == 'advanced'}
                        <Card facedown name="journey" bind:deck={p.decks.journey} c={p.decks.journey[0]} />
                    {/if}-->
                    {#if p.captain != 'Q' && p.decks.missions.length > 0}
                        {#each p.decks.missions as c, index}
                            <Card single hide={$ui.viewing != getPlayerIndex(p)} bind:deck={p.decks.missions} {c} {index}/>
                        {/each}
                    {/if}
                    {#each p.decks.locations as c, index}
                            <Card single hide={$ui.viewing != getPlayerIndex(p)} bind:deck={p.decks.locations} {c} {index}/>
                    {/each}
                </div>
            </div>
            
        </div>

        <div class="row">
            <div style="position: relative; display: flex;">
                {#if p.decks.hasOwnProperty('assimilated')}
                    <div class="legend cardLegend" style="font-size: {$prefs.cardScale}em;">Assimilated: {p.decks.assimilated.length}</div>
                    <Card single tuckDeck={p.decks.assimilated} tuckName="assimilated" c={p.decks.captain[0]} bind:deck={p.decks.captain} />
                    {#if p.decks.captain.length > 1}
                        {#each p.decks.captain.slice(1) as c, index}
                            <Card single bind:deck={p.decks.captain} {c} {index} />
                        {/each}
                    {/if}   
                {:else if p.decks.hasOwnProperty('log')}
                    <div class="legend cardLegend" style="font-size: {$prefs.cardScale}em;">Log: {p.decks.log.length}</div>
                    <Card single tuckDeck={p.decks.log} tuckName="log" c={p.decks.captain[0]} bind:deck={p.decks.captain} />
                    {#if p.decks.captain.length > 1}
                        {#each p.decks.captain.slice(1) as c, index}
                            <Card single bind:deck={p.decks.captain} {c} {index} />
                        {/each}
                    {/if}
                 
                {/if}
            </div>
            {#if displayMemo(`freeman|${p.captain}`, () => ongoingPlayer(p).includes('freeman_cleanup'))}
                <Card single name="clean-up" bind:deck={p.decks.cleanup} c={p.decks.cleanup[0]} index=0 colour="green" />
                {#each p.decks.cleanup.slice(1) as c, index}
                    <Card single name="duty {index+2}" bind:deck={p.decks.cleanup} {c} {index}/>
                {/each}
            {/if}
            <div class="scroll zone" style="flex-wrap: nowrap; height: {$res.cardHeight * $prefs.cardScale * 1.1}vmin;">
                <div class="legend" style="pointer-events: auto; color: lightgrey; font-size: {$prefs.cardScale}em; left: 0;">FLEET</div>
                <div style="display: flex; flex-wrap: nowrap; ">
                    <!--{#each Array(p.decks.fleet.length) as _, i}
                            <Card single bind:deck={p.decks.fleet} c={p.decks.fleet[p.decks.fleet.length - (i+1)]} index={p.decks.fleet.length - (i+1)}/>
                    {/each}-->
                    {#each p.decks.fleet as c, index}
                        {#if c?.deck == 'Q' && c?.suits.includes('status') && p.decks.hasOwnProperty('void')}
                            <div style="position: relative;">
                                <div class="legend cardLegend" style="font-size: {$prefs.cardScale}em;">Void: {p.decks.void.length}</div>
                                <Card single bind:deck={p.decks.fleet} {c} {index} tuckDeck={p.decks.void} tuckName={"void"} />
                            </div>
                        {:else}
                            <Card hide={$ui.viewing != getPlayerIndex(p)} single bind:deck={p.decks.fleet} {c} {index}/>
                        {/if}
                    {/each}
                </div>
            </div>
            
        </div>
        

    <div class="row">
        <Card facedown={!faceupDraw(p)}  c={p.decks.deck[0]} bind:deck={p.decks.deck} name="draw" />
        {#if !p.bot}
            <div bind:this={$ui.handElement[i]} class="scroll" style="{$prefs.showScrollbar ? 'scrollbar-width: unset;' : ''} background-color: darkgreen; flex-wrap: nowrap; height: {$res.cardHeight * $prefs.cardScale}vmin;">
                <div class="legend" style="pointer-events: auto; color: lightgrey; font-size: {$prefs.cardScale}em; left: 0;">HAND</div>
                <div style="display: flex; flex-wrap: nowrap; ">
                    {#each p.decks.hand as c, index}<!--/*$ui.seat != getPlayerIndex(p)*/-->
                        <Card single facedown={$prefs.username != p.username } bind:deck={p.decks.hand} {c} {index}/>
                    {/each}
                </div>
            </div>
            <div class="scroll zone" style="flex-wrap: nowrap; {$prefs.showScrollbar ? 'scrollbar-width: unset;' : ''}; height: {$res.cardHeight * $prefs.cardScale}vmin; background-color: black; padding-top: 0; padding-bottom: 0; min-width: {$res.cardWidth * $prefs.cardScale * 1.5}vmin; width: auto;">
                <div class="legend" style="pointer-events: auto; color: lightgrey; font-size: {$prefs.cardScale}em; left: 0;">STAGING AREA</div>
                <div style="display: flex; flex-wrap: nowrap; ">
                    {#each p.decks.play as c, index}
                            <Card single bind:deck={p.decks.play} {c} {index}/>
                    {/each}
                </div>
            </div>
        {:else}
            <div bind:this={$ui.handElement[i]} class="scroll zone" style="/*overflow-x: scroll; */ background-color: black; flex-wrap: nowrap; height: {$res.cardHeight * $prefs.cardScale}vmin;">
                <div class="legend" style="pointer-events: auto; color: lightgrey; font-size: {$prefs.cardScale}em; left: 0;">STAGING AREA</div>
                <div style="display: flex; flex-wrap: nowrap; ">
                    {#each p.decks.play as c, index}
                            <Card single bind:deck={p.decks.play} {c} {index}/>
                    {/each}
                </div>
            </div>
            <!--<div class="scroll zone" style="flex-wrap: nowrap; height: {$res.cardHeight * $prefs.cardScale}vmin; padding-top: 0; padding-bottom: 0; min-width: {$res.cardWidth * $prefs.cardScale * 1.5}vmin; width: auto;">
                <div class="legend" style="pointer-events: auto; color: lightgrey; font-size: {$prefs.cardScale}em; left: 0;">CHART</div>
                <div style="display: flex; flex-wrap: nowrap; ">
                    Chart goes here
                </div>
            </div>-->
        {/if}
    </div>
</div>

    {#if $state.practice && $state.players[0].captain == 'Borg Queen' && $ui.viewing != getPlayerIndex(p)}
        <div class="area" style="order: 1;">
            <div class="row">{@html convert(`Opponent [[location]]`)}</div>
            <div class="row">
                {#if p.decks.locations.find(c => c.area == 'Advanced Location')}
                    <Card single c={p.decks.locations.find(c => c.area == 'Advanced Location')} bind:deck={p.decks.locations} index={1} />
                {/if}
            </div>
            <div class="row">
                {#if p.decks.locations.find(c => c.area == 'Starting Location')}
                    <Card single c={p.decks.locations.find(c => c.area == 'Starting Location')} bind:deck={p.decks.locations} index={0} />
                {/if}
            </div>
        </div>
    {:else}
        <div class="area" style="order: 1; {$ui.viewing == getPlayerIndex(p) || $prefs.showBoth || $state.practice && getPlayerIndex(p) != 0 ? 'display: none;' : ''}">
            {#if p.captain != 'Q'}
                <div class="row">
                    {#each trackTypesToShow(p) as r}
                        <TokenEdit inc={1} max={trackMax(r)} {p} {r} size={4} />
                    {/each} 
                </div>
            {/if}
            {#if p.bot}
                <div class="row">
                    {p.botLevel}
                </div>
            {/if}
            <div class="row">
                <span on:click={e => {setActivePlayer(i)}} style="cursor: pointer; {$state.activePlayer == i ? 'font-weight: bold;' : ''}">{#if $state.activePlayer == i}👉{/if}{p.captain}
                
                </span>
                {#each Array(p.stardateCards.length) as a}
                    <div style="font-weight: bold; color: yellow; font-size: 1.5em;">!</div>
                {/each}
                <!--<button class="toolbutton" style="font-size: 2vmin;" on:click={e => { $ui.showingTrack = !$ui.showingTrack; }}>Track</button>-->
                {#if $prefs.showScores}({p.score || 0} VP){/if} <!--scorePlayer(p)-->
                {#if p.bot}
                    <button class="toolbutton" style="font-size: 2vmin;" on:click={e => {toggleChart(p, 2)}}>Chart</button>
                {/if}
            </div>
            <div class="row">
                <Card c={p.decks.locations[0]} bind:deck={p.decks.locations} hide={$ui.viewing == getPlayerIndex(p) || $prefs.showBoth} name="locations"/>
            </div>
            <div class="row">
                <Card c={p.decks.fleet[0]} bind:deck={p.decks.fleet} hide={$ui.viewing == getPlayerIndex(p) || $prefs.showBoth} name="fleet"/>
            </div>
        </div>
    {/if}
{/each}
</div>
<div style="display: none;">
    <div bind:this={breakdownElement} style="max-height: 30vh; max-width: 50vw; overflow: auto;" >
        {#if $state.players[$ui.viewing].collected_traits}
            <div class="breakdown_header">{$state.players[$ui.viewing].collected_traits.length} traits collected so far</div>
            {#if $state.players[$ui.viewing].collected_traits.length < desiredTraits.length}
                <div>
                    Traits still to collect: {@html getTraitTicks($state.players[$ui.viewing]).filter(t => !t.ticked).map(t => convert(t.text, true)).join(', ')}
                </div>
            {/if}
        {/if}
        <Breakdown cards={cardsInPlay($state.players[$ui.viewing])} name="Cards in play" />
        <Breakdown cards={allScoreableCards($state.players[$ui.viewing])} name="All scoreable cards" />
        {#if $state.campaign && !$state.players[$ui.viewing].bot && $state.campaignInfo.games && $state.campaignInfo.games.length > 0}
            <div class="breakdown">
                <div class="breakdown_header">Campaign rewards taken so far</div>
                <ul>
                    {#each $state.campaignInfo.games as g}
                        <li>
                            {#if g.reward && g.reward.type && g.reward.type != 'none'}
                                {#if g.reward.text}{g.reward.text}{/if}
                                {#if g.reward.card}({possArray(g.reward.card).map(c => c.name).join(', ')}){/if}
                            {/if}
                        </li>
                    {/each}
                </ul>
            </div>
        {/if}
    </div>
    
</div>
{#if $ui.chart}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div class="bot_chart" on:click={e => {$ui.chart = false;}}>
        <BotChart p={$ui.chart.p} onPick={(ev, row, type) => maybeFakeBotAction(ev, $ui.chart.p, row, type)} />
        {#if $state.campaign}
            <table class="bot_rewards">
                <tr>
                    <td colspan="3"><b>Campaign rewards</b></td>
                </tr>
                {#each ['win', 'lose'] as w}
                    <tr><td colspan="3">
                        If you {w} this game, you can either add a card from reserve or a {@html convert(humanReadableRewards($ui.chart.p.captain, w), true)} to your Reinforcements deck.
                        {#if eligibleRewards(w).length > 0}
                            Eligible cards in your deck: 
                            {#each eligibleRewards(w) as c}
                                <LogCard c={c} />
                            {/each}
                        {:else}
                            No eligible cards in your deck yet.
                        {/if}
                        {#if campaignRewards[$ui.chart.p.captain][w+'_alt']}
                            Alternatively, you can choose from the following:
                            <ul>
                                {#each campaignRewards[$ui.chart.p.captain][w+'_alt'] as r}
                                    <li>{upperInitial(r.type)}: {r.text}</li>
                                {/each}
                            </ul>
                        {/if}
                    </td></tr>
                {/each}
            </table>
        {/if}
    </div>
{/if}

<style>

    .bot_chart {
        position: fixed;
        inset: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: safe center;
        overflow: auto;
        gap: 1vmin;
        background-color: rgba(0, 0, 0, 0.6);
        z-index: 999;
        pointer-events: all;
    }

    .bot_rewards {
        background-color: white;
        color: black;
        font-size: 1.5vmin;
        max-width: 90vw;
    }

    .bot_rewards td {
        border: 1px solid black;
    }

    .area {
        pointer-events: auto;
        display: flex;
        flex-grow: 0;
        flex-shrink: 0;
        flex-basis: auto;
        flex-direction: column;
        flex-wrap: nowrap;
        min-width: 0;
    }

    .growable {
        flex-grow: 2;
        flex-shrink: 1;
    }


    .row {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: flex-end;
        position: relative;
    }

    

    .scroll {
        width: 100%;
        overflow-x: overlay;
        overflow-y: hidden;
        display: flex;
        /*background: darkslategray;*/
        align-items: flex-end;
        position: relative;
        scrollbar-width: none;
        --scrollbar-color: lightgreen;
        row-gap: 1vmin;
        flex-wrap: nowrap;
    }

    .zone {
        /*background-color: black;*/
        border: 2px dashed white;
        padding: 2px;
    }

    
    
    .scroll::-webkit-scrollbar {
    display: block;
    width: 8px;
    }

    .hide_bar::-webkit-scrollbar {
        display: none;
    }

    .scroll::-webkit-scrollbar-button {
    display: none;
    }

    .scroll::-webkit-scrollbar-track {
    background-color: #00000000;
    }

    .scroll::-webkit-scrollbar-track-piece {
    background-color: #00000000;
    }

    .scroll::-webkit-scrollbar-thumb {
    transition: background-color 0.5s;
    background-color: #00000000;
    border: 5px solid transparent;
    border-radius: 24px;
    box-shadow: 4px 0px 0px 4px var(--scrollbar-color) inset;
    }

    .scroll::-webkit-scrollbar-thumb:hover {
    background-color: var(--scrollbar-color);
    border: 0px solid transparent;
    box-shadow: none;
    }

    .legend {
        position: absolute;
        bottom: 1vmin;
        left: 1vmin;
        font-weight: bold;
        font-style: italic;
        z-index: 200;
        text-shadow: 10px 10px 10px black;
        background-color: rgba(0,0,0,0.3);
        padding: 5px;
        border-radius: 10px;
        height: fit-content;
        width: fit-content;
        pointer-events: none;
    }


    .toolbutton {
        font-weight: bold;
        border: 2px solid white;
        padding: 0.25vmin;
        color: white;
        background-color: darkblue;
    }

    .cardLegend {
        color: lightgrey;
        top: 20%;
        text-align: center;
        left: 10%;
        right: 10%;
        margin-left: auto;
        margin-right: auto;
    }

    .hidden {
        display: none;
        width: 0;
    }

    .shown {
        display: block;
        /*animation: fade_in_show 0.5s;*/
    }

    @keyframes fade_in_show {
        0% {
            opacity: 0;
            transform: translate(var(--translate));
        }

        100% {
            opacity: 1;
            transform: translate(0);
        }
    }

    @keyframes fade_out_show {
        0% {
            opacity: 1;
            transform: translate(0);
        }

        100% {
            opacity: 0;
            transform: translate(var(--translate));
        }
    }

    .toolbutton {
        font-weight: bold;
        border: 2px solid white;
        padding: 0.25vmin;
        color: white;
        background-color: darkblue;
        margin: 0;
    }

    .breakdown {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .breakdown_header {
        font-weight: bold;
    }


</style>
